export default [
  {
    companies: "Virksomheder",
    dashboard: "Dashboard",
    delivery_hours: "Leveringstider",
    layouts: "Layouts",
    marketing: "Markedsføring",
    menus: "Menu",
    opening_hours: "Åbningstider",
    order_history: "Ordre historik",
    orders: "Ordre",
    puntuality: "Punktlighed",
    refunds: "Tilbage betalinger",
    settings: "Indstillinger",
    store_details: "Butiks detaljer",
    store_status: "Butiks status",
    stores: "Butikker",
    customers: "Kunder",
    Customers: "Kunder",
    qrCodes: "QR Codes",
    registered: "Oprettet",
    totalOrders: "Antal bestillinger",
    totalOrderedAmount: "Totalt køb",
    firstOrderedDate: "Første bestillings dato",
    averageOrderSize: "Gennemsnits ordre",
    orderValue: "Total kob",
    lastOrderedDate: "Sidste bestillings dato",
    phone: "Telefon",
    firstName: "Fornavn",
    lastName: "Efternavn",
    orderHear: "Bestil her",
    scanQrDesc: "Scan QR koden med dit kamera for at se menu og bestille",
    onlyRegisterCustomers: "Se kun oprettet kunder",
    amount: "Beløb",
    numOrders: "Num Orders",
    newCustomer: "Ny kunde",
    addCredits: "Tilføj kreditter",
    attachCampaign: "Attach Campaign",
    campaignManager: "Campaign Manager",
    campaign: {
      name: "Name",
      description: "Description",
      default_offer: "Default offer",
      season_offer: "Season offer",
      code: "Code",
      from_period: "From period",
      to_period: "To period",
      limit_group: "Limit group",
      public: "Public",
      newCampaign: "New Campaign",
    },
    automation: {
      name: "Name",
      description: "Description",
      code: "Code",
      from_period: "From period",
      to_period: "To period",
      active: "Active",
      newReward: "New reward",
      newAutomation: "New automation",
    },
    promotions: {
      title: "Fordele ved rabat kode",
      description1:
        "Kunder deler ofte rabat koder med deres venner og familie hvilket kan øge virksomhedens eksponering og tiltrække nye kunder.",
      description2:
        "Dine kunder kan også blive tiltrukket af en promo kampagne for at prøve et nyt produkt, de måske ikke ellers ville have prøvet.",
      description3:
        "Lad dine kunder dele med deres familie og venner deres egne “Koder”. Vi anbefaler at belønne kunden med 50,00 dkk for en henvisning. Din kunde modtager 50,00 dkk, når de har inviteret en ven / familie når deres “Ven” har købt sin første ordre. Den ven som bliver inviteret ville også modtage 50,00 dkk i rabat til den første bestilling.",
      inputTitle:
        "Hvor meget ønsker du at belønne dine kunder for at henvise dig?",
      info: "NB! belønning opnås kun ved at købe beløbet x 2 som minimum.",
      save: "Gem",
    },
    store: {
      use_3pd_charge: "Brug 3PD-gebyr",
      discount_percentage: "Rabat i procent",
      delivery_with_vat: "Levering med moms",
      discount_amount: "Rabat i beløb",
      free_delivery_at: "Fri levering opnås ved køb af ",
      max_delivery_fee: "Max pris for levering ",
      should_pay_vat: "Skal kunden betale moms?",
      discount_on_delivery_from_amount: "Skal kunden betale for moms",
      discount_on_delivery_fee_from: "Rabat på levering starter fra",
      priceModalTitle: "Butiks Prisfastsættelses Konfiguration",
      configureDeliveryPartners: "Konfigurer leverings partner",
      venueId: "Sted-Id",
      deliveryPartners: "Leverings partner",
      alreadyConfigured:
        "Advarsel: Du har allerede konfigureret denne leveringspartner.",
    },
    company: {
      keyFormTitle: "Konfigurér partnernøgler",
      apiKey: "API-nøgle",
      merchantId: "Forhandler-ID",
      clientId: "Klient-ID",
      partnerIdent: "Partner Identifikation",
    },
  },
];
